const NUMERIC_LITERAL = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/;

export const isPlainNumericLiteral = (value: unknown): boolean => NUMERIC_LITERAL.test(String(value ?? '').trim());

export const isUnsupportedNumericRawValue = (rawValue: unknown): boolean => {
  const rawText = String(rawValue ?? '').trim();
  if (!rawText) return false;
  return !isPlainNumericLiteral(rawText);
};
